import IsLoaded from "common/isLoaded";
import { Trader } from "./trader";
import { loadTraders } from "./traders.actions";
import { isNotCustomer, useLazyLoader } from "common/redux/useLazySelector";

const defaultVal: Trader[] = [];
export default function useTraders(): IsLoaded<Trader[]> {
    return useLazyLoader(m => m.traders, dispatch => loadTraders()(dispatch), isNotCustomer, defaultVal);
}